export default __webpack_public_path__ + "static/media/ic-identification.de2e789d.svg";